module.exports = __webpack_public_path__ + "static/img/setting.944c340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/setting.png
// module id = HLwj
// module chunks = 1